import {
  IconAtom,
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
} from '@assets/images/icon';
import { IconAnalyze, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';

export default {
  specTitle: {},

  specData: [
    {
      data: [{ title: '产品名称' }, { text1: '手机出入' }, { text2: '自动门出入' }, { text3: '人脸识别出入' }],
    },
    {
      data: [
        { text: '说明' },
        { text: '用手机软件控制出入门的非常简便的机器' },
        { text: '无需运行应用程序即可方便出入的机器' },
        { text: '人脸识别、NFC卡等多种出入一次性使用的机器' },
      ],
    },
    {
      data: [{ text: '电源供应' }, { text: '电池使用（最多3年）' }, { text: 'DC 12V, 24V ' }, { text: 'DC 12V, 3A' }],
    },
  ],

  a: [
    { text: '通信频段', icon: IconSignal },
    { text: '通信范围', icon: IconCoil },
    { text: '精确度', icon: IconRuler },
    { text: '资产查找', icon: IconSearch },
    { text: '角度测量<br/>AoA', icon: IconRuler },
    { text: '高精度追踪<br/>ATDoA', icon: IconAtom },

    { text: '供电方式', icon: IconPower },
    { text: '电池消耗', icon: IconEnergyCircle },
    { text: '安装难度', icon: IconTools },
    { text: '使用空间', icon: IconBuildings },
    { text: '推荐环境', icon: IconBookmark },
    { text: '主要优势', icon: IconPencil },
    { text: '外部集成', icon: IconShare },
  ],

  b: [
    { text: '3.1～10.6GHz' },
    { text: '<50米' },
    { text: '10厘米以下' },
    { text: '1' },
    { text: '-' },
    { text: '1' },
    { text: 'PoE' },
    { text: '中等' },
    { text: '★★★' },
    { text: '智能工厂、港口' },
    { text: '工厂、物流仓库、造船厂、工厂装置、建筑工地等' },
    { text: '可实现厘米级超精确定位跟踪<br/>即使在噪声环境中也能运行' },
    { text: '提供API' },
  ],
  c: [
    { text: '2.4GHz' },
    { text: '<30米' },
    { text: '10～30厘米' },
    { text: '1' },
    { text: '1' },
    { text: '-' },
    { text: 'PoE' },
    { text: '低' },
    { text: '★★☆' },
    { text: '智能楼宇、大型室内' },
    { text: '办公、医院、物流自动化、研究设施' },
    { text: '单个安装即可跟踪周边标签位置' },
    { text: '提供API' },
  ],

  d: [
    { text: '2.4GHz' },
    { text: '最大100米' },
    { text: '10厘米以上' },
    { text: '1' },
    { text: '-' },
    { text: '-' },
    { text: 'PoE' },
    { text: '非常低' },
    { text: '★☆☆' },
    { text: '仓库、医院、资产管理空间等' },
    { text: '大规模资产管理' },
    { text: '部署成本低<br/>标签电池消耗少' },
    { text: '提供API' },
  ],

  e: [
    { text: '3.1～10.6GHz' },
    { text: '20米' },
    { text: '10～30厘米' },
    { text: '-' },
    { text: '-' },
    { text: '1' },
    { text: '可充电电池' },
    { text: '高' },
    { text: '★☆☆' },
    { text: '小规模演示、临时空间' },
    { text: '临时使用现场、小型空间、难以进行基础设施施工的地方' },
    { text: '无需锚点安装<br/>便携性高' },
    { text: '不提供（仅限应用）' },
  ],
  spec: [
    {},
    {
      image: schemeUwb,
      link: '/cn/rtls/uwb',
      title: 'TwinTracker UWB',
      desc: 'UWB',
    },
    {
      image: schemeAoa,
      link: '/cn/rtls/aoa',
      title: 'TwinTracker AoA',
      desc: 'BLE + AoA',
    },
    {
      image: schemeBle,
      link: '/cn/rtls/ble',
      title: 'TwinTracker BLE',
      desc: 'BLE',
    },
    {
      image: schemeComfort,
      link: '/cn/rtls/comfort',
      title: 'Comfort Kit',
      desc: 'UWB',
    },
  ],
};
